import React, { useState } from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function FamilyAssessmentPage() {
  const [currentStep, setCurrentStep] = useState(1);
  const totalSteps = 5;
  const goToNextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };
  const goToPreviousStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };
  return <div className="w-full min-h-screen bg-[#f8f8f8] py-12 px-6" data-id="element-1223">
      <div className="max-w-4xl mx-auto" data-id="element-1224">
        {/* Back button */}
        <div className="mb-8" data-id="element-1225">
          <Link to="/assessment" className="flex items-center text-gray-600 hover:text-[#631bb7] transition-colors" data-id="element-1226">
            <ArrowLeftIcon size={20} className="mr-2" data-id="element-1227" />
            <span className="font-medium" data-id="element-1228">Back</span>
          </Link>
        </div>
        {/* Progress indicator */}
        <div className="mb-8" data-id="element-1229">
          <div className="flex justify-between items-center mb-2" data-id="element-1230">
            <span className="text-sm font-bold text-[#631bb7]" data-id="element-1231">
              Step {currentStep} of {totalSteps}
            </span>
            <span className="text-sm font-semibold text-gray-500" data-id="element-1232">
              {Math.round(currentStep / totalSteps * 100)}% Complete
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-1233">
            <div className="bg-[#631bb7] h-2 rounded-full transition-all duration-300" style={{
            width: `${currentStep / totalSteps * 100}%`
          }} data-id="element-1234"></div>
          </div>
        </div>
        {/* Assessment Content */}
        <div className="bg-white rounded-2xl p-8 border-2 border-gray-200" data-id="element-1235">
          {currentStep === 1 && <div data-id="element-1236">
              <h1 className="text-3xl md:text-4xl font-bold text-[#111111] mb-6" data-id="element-1237">
                Tell us about your family
              </h1>
              <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-1238">
                We'll customize your experience based on your family's needs.
              </p>
              <div className="space-y-6 mb-8" data-id="element-1239">
                <div className="border-2 border-gray-200 rounded-xl p-6" data-id="element-1240">
                  <h3 className="text-xl font-bold text-[#111111] mb-4" data-id="element-1241">
                    How many family members do you want to protect?
                  </h3>
                  <div className="space-y-3" data-id="element-1242">
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-1243">
                      <input type="radio" name="family_size" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-1244" />
                      <span className="font-medium" data-id="element-1245">2-3 people</span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-1246">
                      <input type="radio" name="family_size" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-1247" />
                      <span className="font-medium" data-id="element-1248">4-5 people</span>
                    </label>
                    <label className="flex items-center p-4 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-[#631bb7] transition-colors" data-id="element-1249">
                      <input type="radio" name="family_size" className="mr-3 w-4 h-4 accent-[#631bb7]" data-id="element-1250" />
                      <span className="font-medium" data-id="element-1251">More than 5 people</span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="flex justify-end" data-id="element-1252">
                <button onClick={goToNextStep} className="bg-[#631bb7] text-white px-8 py-3 rounded-lg font-bold hover:bg-[#521099] transition-all shadow-md" data-id="element-1253">
                  Continue
                </button>
              </div>
            </div>}
          {currentStep > 1 && <div data-id="element-1254">
              <h1 className="text-3xl md:text-4xl font-bold text-[#111111] mb-6" data-id="element-1255">
                Assessment Step {currentStep}
              </h1>
              <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-1256">
                This is a placeholder for step {currentStep} of the assessment.
              </p>
              <div className="flex justify-between" data-id="element-1257">
                <button onClick={goToPreviousStep} className="border-2 border-gray-300 text-[#111111] px-8 py-3 rounded-lg font-bold hover:border-[#631bb7] hover:text-[#631bb7] transition-colors" data-id="element-1258">
                  Back
                </button>
                <button onClick={goToNextStep} className="bg-[#631bb7] text-white px-8 py-3 rounded-lg font-bold hover:bg-[#521099] transition-all shadow-md" data-id="element-1259">
                  Continue
                </button>
              </div>
            </div>}
        </div>
      </div>
    </div>;
}